export const abi = [
  {
    name: 'CreateTokenSale',
    type: 'event',
    inputs: [
      {
        name: 'instanceAddress',
        type: 'address',
        indexed: false,
        internalType: 'address',
      },
    ],
    anonymous: false,
  },
  {
    name: 'Initialized',
    type: 'event',
    inputs: [
      { name: 'version', type: 'uint8', indexed: false, internalType: 'uint8' },
    ],
    anonymous: false,
  },
  {
    name: 'RoleAdminChanged',
    type: 'event',
    inputs: [
      { name: 'role', type: 'bytes32', indexed: true, internalType: 'bytes32' },
      {
        name: 'previousAdminRole',
        type: 'bytes32',
        indexed: true,
        internalType: 'bytes32',
      },
      {
        name: 'newAdminRole',
        type: 'bytes32',
        indexed: true,
        internalType: 'bytes32',
      },
    ],
    anonymous: false,
  },
  {
    name: 'RoleGranted',
    type: 'event',
    inputs: [
      { name: 'role', type: 'bytes32', indexed: true, internalType: 'bytes32' },
      {
        name: 'account',
        type: 'address',
        indexed: true,
        internalType: 'address',
      },
      {
        name: 'sender',
        type: 'address',
        indexed: true,
        internalType: 'address',
      },
    ],
    anonymous: false,
  },
  {
    name: 'RoleRevoked',
    type: 'event',
    inputs: [
      { name: 'role', type: 'bytes32', indexed: true, internalType: 'bytes32' },
      {
        name: 'account',
        type: 'address',
        indexed: true,
        internalType: 'address',
      },
      {
        name: 'sender',
        type: 'address',
        indexed: true,
        internalType: 'address',
      },
    ],
    anonymous: false,
  },
  {
    name: 'SetAirdrop',
    type: 'event',
    inputs: [
      {
        name: 'airdrop',
        type: 'address',
        indexed: false,
        internalType: 'address',
      },
    ],
    anonymous: false,
  },
  {
    name: 'DEFAULT_ADMIN_ROLE',
    type: 'function',
    inputs: [],
    outputs: [{ name: '', type: 'bytes32', internalType: 'bytes32' }],
    stateMutability: 'view',
  },
  {
    name: 'OPERATOR',
    type: 'function',
    inputs: [],
    outputs: [{ name: '', type: 'bytes32', internalType: 'bytes32' }],
    stateMutability: 'view',
  },
  {
    name: 'POINT_BASE',
    type: 'function',
    inputs: [],
    outputs: [{ name: '', type: 'uint256', internalType: 'uint256' }],
    stateMutability: 'view',
  },
  {
    name: 'STAKING',
    type: 'function',
    inputs: [],
    outputs: [{ name: '', type: 'bytes32', internalType: 'bytes32' }],
    stateMutability: 'view',
  },
  {
    name: 'USDB',
    type: 'function',
    inputs: [],
    outputs: [{ name: '', type: 'address', internalType: 'address' }],
    stateMutability: 'view',
  },
  {
    name: 'addOperator',
    type: 'function',
    inputs: [{ name: '_address', type: 'address', internalType: 'address' }],
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    name: 'addToBlackList',
    type: 'function',
    inputs: [
      { name: '_instance', type: 'address', internalType: 'address' },
      { name: '_blacklist', type: 'address[]', internalType: 'address[]' },
    ],
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    name: 'blacklist',
    type: 'function',
    inputs: [
      { name: '', type: 'address', internalType: 'address' },
      { name: '', type: 'address', internalType: 'address' },
    ],
    outputs: [{ name: '', type: 'bool', internalType: 'bool' }],
    stateMutability: 'view',
  },
  {
    name: 'blockClaim',
    type: 'function',
    inputs: [{ name: '', type: 'address', internalType: 'address' }],
    outputs: [{ name: '', type: 'bool', internalType: 'bool' }],
    stateMutability: 'view',
  },
  {
    name: 'createPoolNew',
    type: 'function',
    inputs: [
      {
        name: '_params',
        type: 'tuple',
        components: [
          { name: 'tokenAddress', type: 'address', internalType: 'address' },
          { name: 'totalSupply', type: 'uint256', internalType: 'uint256' },
          { name: 'tokenPrice', type: 'uint256', internalType: 'uint256' },
          { name: 'saleStart', type: 'uint96', internalType: 'uint96' },
          { name: 'saleEnd', type: 'uint96', internalType: 'uint96' },
          {
            name: 'liqudityPercentage',
            type: 'uint64',
            internalType: 'uint64',
          },
          { name: 'tokenLiquidity', type: 'uint256', internalType: 'uint256' },
          { name: 'LPLockin', type: 'uint256', internalType: 'uint256' },
          { name: 'vestingPeriod', type: 'uint256', internalType: 'uint256' },
          { name: 'baseLine', type: 'uint256', internalType: 'uint256' },
          { name: 'burnUnsold', type: 'bool', internalType: 'bool' },
        ],
        internalType: 'struct ITokenSale.Params',
      },
      { name: '_maxAllocation', type: 'uint256', internalType: 'uint256' },
      { name: '_isKYC', type: 'bool', internalType: 'bool' },
    ],
    outputs: [],
    stateMutability: 'payable',
  },
  {
    name: 'creators',
    type: 'function',
    inputs: [{ name: '', type: 'address', internalType: 'address' }],
    outputs: [{ name: '', type: 'bool', internalType: 'bool' }],
    stateMutability: 'view',
  },
  {
    name: 'destroyInstance',
    type: 'function',
    inputs: [{ name: '_instance', type: 'address', internalType: 'address' }],
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    name: 'factory',
    type: 'function',
    inputs: [],
    outputs: [{ name: '', type: 'address', internalType: 'address' }],
    stateMutability: 'view',
  },
  {
    name: 'getParams',
    type: 'function',
    inputs: [{ name: '_instance', type: 'address', internalType: 'address' }],
    outputs: [
      {
        name: '',
        type: 'tuple',
        components: [
          { name: 'tokenAddress', type: 'address', internalType: 'address' },
          { name: 'totalSupply', type: 'uint256', internalType: 'uint256' },
          { name: 'tokenPrice', type: 'uint256', internalType: 'uint256' },
          { name: 'saleStart', type: 'uint96', internalType: 'uint96' },
          { name: 'saleEnd', type: 'uint96', internalType: 'uint96' },
          {
            name: 'liqudityPercentage',
            type: 'uint64',
            internalType: 'uint64',
          },
          { name: 'tokenLiquidity', type: 'uint256', internalType: 'uint256' },
          { name: 'LPLockin', type: 'uint256', internalType: 'uint256' },
          { name: 'vestingPeriod', type: 'uint256', internalType: 'uint256' },
          { name: 'baseLine', type: 'uint256', internalType: 'uint256' },
          { name: 'burnUnsold', type: 'bool', internalType: 'bool' },
        ],
        internalType: 'struct ITokenSale.Params',
      },
    ],
    stateMutability: 'view',
  },
  {
    name: 'getRoleAdmin',
    type: 'function',
    inputs: [{ name: 'role', type: 'bytes32', internalType: 'bytes32' }],
    outputs: [{ name: '', type: 'bytes32', internalType: 'bytes32' }],
    stateMutability: 'view',
  },
  {
    name: 'getTokenSales',
    type: 'function',
    inputs: [],
    outputs: [{ name: '', type: 'address[]', internalType: 'address[]' }],
    stateMutability: 'view',
  },
  {
    name: 'getTokenSalesCount',
    type: 'function',
    inputs: [],
    outputs: [{ name: '', type: 'uint256', internalType: 'uint256' }],
    stateMutability: 'view',
  },
  {
    name: 'grantRole',
    type: 'function',
    inputs: [
      { name: 'role', type: 'bytes32', internalType: 'bytes32' },
      { name: 'account', type: 'address', internalType: 'address' },
    ],
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    name: 'hasRole',
    type: 'function',
    inputs: [
      { name: 'role', type: 'bytes32', internalType: 'bytes32' },
      { name: 'account', type: 'address', internalType: 'address' },
    ],
    outputs: [{ name: '', type: 'bool', internalType: 'bool' }],
    stateMutability: 'view',
  },
  {
    name: 'indexOfTokenSales',
    type: 'function',
    inputs: [{ name: '', type: 'address', internalType: 'address' }],
    outputs: [{ name: '', type: 'uint256', internalType: 'uint256' }],
    stateMutability: 'view',
  },
  {
    name: 'initialize',
    type: 'function',
    inputs: [
      { name: '_owner', type: 'address', internalType: 'address' },
      { name: '_router', type: 'address', internalType: 'address' },
      { name: '_factory', type: 'address', internalType: 'address' },
    ],
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    name: 'isKYCDone',
    type: 'function',
    inputs: [{ name: '', type: 'address', internalType: 'address' }],
    outputs: [{ name: '', type: 'bool', internalType: 'bool' }],
    stateMutability: 'view',
  },
  {
    name: 'masterTokenSale',
    type: 'function',
    inputs: [],
    outputs: [{ name: '', type: 'address', internalType: 'address' }],
    stateMutability: 'view',
  },
  {
    name: 'platformFee',
    type: 'function',
    inputs: [],
    outputs: [{ name: '', type: 'uint256', internalType: 'uint256' }],
    stateMutability: 'view',
  },
  {
    name: 'platformTax',
    type: 'function',
    inputs: [],
    outputs: [{ name: '', type: 'uint256', internalType: 'uint256' }],
    stateMutability: 'view',
  },
  {
    name: 'removeClaimBlock',
    type: 'function',
    inputs: [{ name: '_address', type: 'address', internalType: 'address' }],
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    name: 'removeOperator',
    type: 'function',
    inputs: [{ name: '_address', type: 'address', internalType: 'address' }],
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    name: 'renounceRole',
    type: 'function',
    inputs: [
      { name: 'role', type: 'bytes32', internalType: 'bytes32' },
      { name: 'account', type: 'address', internalType: 'address' },
    ],
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    name: 'revokeRole',
    type: 'function',
    inputs: [
      { name: 'role', type: 'bytes32', internalType: 'bytes32' },
      { name: 'account', type: 'address', internalType: 'address' },
    ],
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    name: 'router',
    type: 'function',
    inputs: [],
    outputs: [{ name: '', type: 'address', internalType: 'address' }],
    stateMutability: 'view',
  },
  {
    name: 'setClaimBlock',
    type: 'function',
    inputs: [{ name: '_address', type: 'address', internalType: 'address' }],
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    name: 'setFactory',
    type: 'function',
    inputs: [{ name: '_factory', type: 'address', internalType: 'address' }],
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    name: 'setMasterContract',
    type: 'function',
    inputs: [{ name: '_address', type: 'address', internalType: 'address' }],
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    name: 'setPlatformFee',
    type: 'function',
    inputs: [{ name: '_fee', type: 'uint256', internalType: 'uint256' }],
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    name: 'setPlatformTax',
    type: 'function',
    inputs: [{ name: '_tax', type: 'uint256', internalType: 'uint256' }],
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    name: 'setRouter',
    type: 'function',
    inputs: [{ name: '_router', type: 'address', internalType: 'address' }],
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    name: 'setUserKYC',
    type: 'function',
    inputs: [{ name: 'users', type: 'address[]', internalType: 'address[]' }],
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    name: 'setWallet',
    type: 'function',
    inputs: [{ name: '_address', type: 'address', internalType: 'address' }],
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    name: 'supportsInterface',
    type: 'function',
    inputs: [{ name: 'interfaceId', type: 'bytes4', internalType: 'bytes4' }],
    outputs: [{ name: '', type: 'bool', internalType: 'bool' }],
    stateMutability: 'view',
  },
  {
    name: 'tokenSales',
    type: 'function',
    inputs: [{ name: '', type: 'uint256', internalType: 'uint256' }],
    outputs: [{ name: '', type: 'address', internalType: 'address' }],
    stateMutability: 'view',
  },
  {
    name: 'tokenSalesM',
    type: 'function',
    inputs: [{ name: '', type: 'address', internalType: 'address' }],
    outputs: [{ name: '', type: 'bool', internalType: 'bool' }],
    stateMutability: 'view',
  },
  {
    name: 'wallet',
    type: 'function',
    inputs: [],
    outputs: [{ name: '', type: 'address', internalType: 'address' }],
    stateMutability: 'view',
  },
]
